import Vue from 'vue'
import Router from 'vue-router'

import Admin from '@/admin/App.vue'
import Dashboard from '@/admin/views/Dashboard.vue'
import Register from '@/admin/views/Register.vue'
import Words from '@/admin/views/Words.vue'
import AddWords from '@/admin/views/words/AddWords.vue'
import EditWords from '@/admin/views/words/EditWords.vue'
import Users from '@/admin/views/Users.vue'
import AddUsers from '@/admin/views/users/AddUsers.vue'
import EditUsers from '@/admin/views/users/EditUsers.vue'
import NewWords from '@/admin/views/NewWords.vue'
import EditNewWords from '@/admin/views/new-words/EditWords.vue'
import Feedback from '@/admin/views/Feedback.vue'
import About from '@/admin/views/About.vue'

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/admin/',
      name: 'admin',
      component: Admin,
      redirect: '/admin/dashboard',
      meta: {
        requiresAuth: true,
        is_admin: true
      },
      children: [
        {
          name: 'dashboard',
          path: 'dashboard',
          component: Dashboard
        },
        {
          path: 'register',
          component: Register
        },
        {
          name: 'words',
          path: 'words',
          component: Words,
          meta: {
            category: 'words'
          }
        },
        {
          name: 'add-words',
          path: 'add-words',
          component: AddWords,
          meta: {
            category: 'words'
          }
        },
        {
          name: 'edit-words',
          path: 'edit-words/:id',
          component: EditWords,
          meta: {
            category: 'words'
          }
        },
        {
          name: 'new-words',
          path: 'new-words',
          component: NewWords,
          meta: {
            back: true
          }
        },
        {
          name: 'edit-new-words',
          path: 'edit-new-words/:id',
          component: EditNewWords,
          meta: {
            back: true
          }
        },
        {
          name: 'users',
          path: 'users',
          component: Users,
          meta: {
            category: 'users'
          }
        },
        {
          name: 'add-users',
          path: 'add-users',
          component: AddUsers,
          meta: {
            category: 'users'
          }
        },
        {
          name: 'edit-users',
          path: 'edit-users/:id',
          component: EditUsers,
          meta: {
            category: 'users'
          }
        },
        {
          name: 'feedback',
          path: 'feedback',
          component: Feedback,
          meta: {
            back: true
          }
        },
        {
          path: 'about',
          component: About
        },
        {
          path: '*',
          name: 'error-admin',
          redirect: '/admin'
        }
      ]
    },
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/views/About.vue')
    },
    {
      path: '/favorites',
      name: 'favorites',
      component: () => import('@/views/Favorites.vue')
    },
    {
      path: '/dictionary',
      name: 'dictionary',
      component: () => import('@/views/Dictionary.vue')
    },
    {
      path: '/*',
      name: '404',
      component: () => import('@/views/404.vue')
      //component: (require('@/scss/app.scss'), require('@/views/404.vue').default)
    }
  ]
})
